<template>
  <div class="md-layout">
    <SearchTable
      ref="table"
      @checked="updateInvoiceCheck"
      :header="
        isFilterOn('confirmed')
          ? {
              title: 'Radni nalozi',
              icon: 'work',
              class: 'md-card-header-brand',
            }
          : {
              title: 'Kalkulacije',
              icon: 'outbox',
              class: 'md-card-header-brand',
            }
      "
      :key="reloading"
      :queriedData="modifiedFiles"
      :metaData="metaData"
      :getItems="getOffersOrOfferGroups"
      :params="params"
      :sortBy="isFilterOn('confirmed') ? 'confirmedAt' : 'dateCreated'"
      :newItem="newOffer"
      :openItem="openOfferOrOfferGroup"
      :templates="templates"
      :forEachSelected="forEachSelectedFiltered"
      :individualFunction="[
        { function: copyOffer, class: 'md-round', icon: 'content_copy' },
      ]"
      :highlightRows="highlightRows"
    />
    <OfferModal
      v-if="selectedOfferId !== null && loaded"
      :id="parseInt(selectedOfferId)"
      @modal-hide="modalHide()"
      @saved-offer="
        modalHide();
        getOffersOrOfferGroups();
      "
    />
  </div>
</template>

<script>
import SearchTable from '@/components/SearchTable.vue';
import OfferModal from '@/components/OfferModal.vue';
import services from '@/api/services';
import api from '@/api/api.js';
import Swal from 'sweetalert2';
import { cases } from '@/utils/helpers';
import { openPdfInNewTab } from '../utils/helpers';
export default {
  components: {
    OfferModal,
    SearchTable,
  },

  data() {
    return {
      files: [],
      fileGroups: [],
      selectedGroup: null,
      params: null,
      metaData: null,
      reloading: 0,
      canGetInvoice: false,
      canGetOffer: false,
      canSplit: false,
      loaded: false,
      numOfChecked: 0,
      templates: [
        {
          name: 'Samo završeno',
          params: {
            id: null,
            name: '',
            clientName: '',
            creatorName: '',
            inChargeName: '',
            contactPerson: '',
            jobName: '',
            circulation: [null, null],
            discountedPrice: [null, null],
            confirmed: ['1', '0'],
            invoiced: ['1', '0'],
            done: ['1'],
            sent: ['1', '0'],
          },
        },
        {
          name: 'Samo poslato',
          params: {
            id: null,
            name: '',
            clientName: '',
            creatorName: '',
            inChargeName: '',
            contactPerson: '',
            jobName: '',
            circulation: [null, null],
            discountedPrice: [null, null],
            confirmed: ['1', '0'],
            invoiced: ['1', '0'],
            done: ['1', '0'],
            sent: ['1'],
          },
        },
      ],
    };
  },
  computed: {
    selectedOfferId() {
      if (this.$route.query.id === undefined) {
        return null;
      } else {
        return this.$route.query.id;
      }
    },
    forEachSelectedFiltered() {
      const forEachSelected = [];
      if (!this.isFilterOn('confirmed') && this.canGetOffer)
        forEachSelected.push(
          {
            label: 'Generiši ponudu',
            class: 'md-primary',
            icon: 'sticky_note_2',
            function: this.downloadOffer,
          },
          {
            label: 'Generiši radne naloge',
            class: 'md-primary',
            icon: 'fact_check',
            function: this.generateConfirmedOffers,
          },
        );
      else if (this.canGetOffer && this.numOfChecked > 1)
        forEachSelected.push({
          label: 'Grupiši',
          class: 'md-primary',
          icon: 'call_merge',
          function: this.linkGroup,
        });
      if (this.isFilterOn('confirmed') && this.canSplit)
        forEachSelected.push({
          label: 'Razdvoji',
          class: 'md-warning',
          icon: 'call_split',
          function: this.splitGroup,
        });
      if (this.isFilterOn('confirmed') && this.canGetInvoice)
        forEachSelected.push({
          label: 'Generiši fakturu',
          class: 'md-primary',
          icon: 'request_page',
          function: this.generateInvoice,
        });
      forEachSelected.push({
        label: 'Briši',
        class: 'md-danger',
        icon: 'delete',
        function: this.deleteOffers,
      });
      return forEachSelected;
    },
    modifiedFiles() {
      if (!this.isFilterOn()) {
        return this.files;
      } else if (this.isFilterOn('confirmed') && this.selectedGroup) {
        let modifiedFiles = [];
        this.fileGroups.forEach(fileGroup => {
          modifiedFiles.push(fileGroup);
          if (this.selectedGroup === fileGroup.id) {
            modifiedFiles = modifiedFiles.concat(this.files);
          }
        });
        return modifiedFiles;
      } else {
        return this.fileGroups;
      }
    },
    highlightRows() {
      if (this.isFilterOn('confirmed') && this.selectedGroup) {
        const ids = this.selectedGroup.split(',');
        return this.modifiedFiles.reduce((highlightRows, file, index) => {
          if (ids.includes(String(file.id))) highlightRows.push(index);
          return highlightRows;
        }, []);
      }
      return [];
    },
  },
  methods: {
    getOffersOrOfferGroups(printTable = false) {
      if (this.$route.query?.filter === 'confirmed') {
        return this.getOfferGroups(printTable);
      } else {
        return this.getOffers(printTable);
      }
    },

    getOfferGroups(printTable = false) {
      const offset = this.metaData ? this.$refs.table.from : 0;
      const limit = this.metaData ? this.$refs.table.pagination.perPage : 75;
      const sortBy = this.$refs.table.currentSort || 'confirmedAt';
      const sortOrder = this.$refs.table.currentSortOrder;
      api
        .get(services.getOfferGroups, {
          loadOfferGroups: true,
          params: this.params,
          offset,
          limit,
          sortBy,
          sortOrder,
          printTable,
        })
        .then(data => {
          this.fileGroups = data.data;
          this.metaData = data.metaData;
          this.total = parseInt(data.metaData.total);
          if (this.selectedGroup) {
            this.getOffers(false, this.selectedGroup);
          }
        })
        .then(() => {
          this.loaded = true;
          this.reloading++;
        })
        .catch(error => {
          this.alertError(error);
        });
    },

    getOffers(printTable = false, groupIds = null) {
      const offset = this.metaData ? this.$refs.table.from : 0;
      const limit = this.metaData ? this.$refs.table.pagination.perPage : 75;
      const sortBy =
        this.isFilterOn('confirmed') || !this.$refs.table.currentSort
          ? 'dateCreated'
          : this.$refs.table.currentSort;
      const sortOrder = this.metaData
        ? this.$refs.table.currentSortOrder
        : 'desc';
      api
        .get(services.getOffers, {
          loadOffers: true,
          params: this.params,
          offset,
          limit,
          sortBy,
          sortOrder,
          filter: this.$route.query?.filter ?? null,
          printTable,
          groupIds,
        })
        .then(data => {
          this.files = data.data;
          if (!this.isFilterOn()) {
            this.metaData = data.metaData;
            this.total = parseInt(data.metaData.total);
          }
        })
        .then(() => {
          this.loaded = true;
          this.reloading++;
        })
        .catch(error => {
          this.alertError(error);
        });
    },
    openOfferOrOfferGroup(value) {
      const idAttribute = `${value.id}`;
      if (idAttribute.match(/^\d+$/)) {
        if (this.selectedGroup && !this.selectedGroup.includes(idAttribute))
          this.selectedGroup = null;
        this.openOffer(value);
      } else {
        this.selectedGroup = value.id;
        this.getOffers(false, value.id);
      }
    },
    openOffer(value) {
      const id = value.id;
      const query = { id };
      if (this.isFilterOn('confirmed'))
        Object.assign(query, { filter: 'confirmed' });
      this.$router.push({ path: 'files', query });
    },
    copyOffer(data) {
      api.get(services.getOffer, { offerId: data.id, copy: true }).then(
        () => {
          const query = { id: 0 };
          if (this.isFilterOn('confirmed'))
            Object.assign(query, { filter: 'confirmed' });
          this.$router.push({ path: 'files', query });
        },
        error => {
          this.alertError(error);
        },
      );
    },
    newOffer() {
      const query = { id: 0 };
      if (this.isFilterOn('confirmed'))
        Object.assign(query, { filter: 'confirmed' });
      this.$router.push({ path: 'files', query });
    },
    modalHide() {
      const query = {};
      if (this.isFilterOn('confirmed'))
        Object.assign(query, { filter: 'confirmed' });
      this.$router.push({ path: 'files', query });
    },
    getOfferId() {
      if (this.$route.query !== null) {
        if (this.$route.query.id !== null) return this.$router.query.id;
        else return false;
      } else {
        return false;
      }
    },
    isFilterOn(filter = null) {
      if (filter === null) return !!this.$route.query?.filter;
      else return this.$route.query?.filter === filter;
    },
    modifyParams() {
      const params = {
        id: null,
        name: '',
        clientName: '',
        creatorName: '',
        inChargeName: '',
        contactPerson: '',
        jobName: '',
        invoiced: ['1', '0'],
        done: ['1', '0'],
        sent: ['1', '0'],
      };

      if (this.isFilterOn('confirmed')) {
        const booleanGroups = ['partial', 'true', 'false'];
        params.sent = params.done = booleanGroups;
        params.invoiced = ['false'];
        this.params = params;
        return;
      }

      params.confirmed = ['0'];
      params.circulation = [null, null];
      params.discountedPrice = [null, null];

      return (this.params = params);
    },
    deleteOffers(items) {
      const ids = items.map(el => el.id);
      return Swal.fire({
        title: 'Obriši ponude?',
        text: `Da li ste sigurni da želite da obrišete ${ids.length} ${cases(
          ids.length,
          'ponudu',
          'ponude',
          'ponuda',
        )}?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-danger btn-fill',
        cancelButtonClass: 'md-button btn-fill',
        confirmButtonText: 'Obriši!',
        cancelButtonText: 'Otkaži',
        buttonsStyling: false,
      }).then(data => {
        if (data.value) {
          (() => {
            if (ids.length >= 5) {
              return Swal.fire({
                title: 'Obriši ponude?',
                text: `Označili ste ${ids.length} ${cases(
                  ids.length,
                  'ponudu',
                  'ponude',
                  'ponuda',
                )} za brisanje. Potvrdite još jednom da želite da nastavite.`,
                type: 'warning',
                showCancelButton: true,
                cancelButtonClass: 'md-button btn-fill',
                confirmButtonClass: 'md-button md-danger btn-fill',
                confirmButtonText: 'Obriši!',
                cancelButtonText: 'Otkaži',
                buttonsStyling: false,
              });
            } else {
              return Promise.resolve(data);
            }
          })().then(data => {
            if (data.value) {
              api
                .post(services.offers.deleteOffers, {
                  deleteOffers: true,
                  ids,
                })
                .then(() => {
                  this.getOffersOrOfferGroups();
                  this.$refs.table.removeChecked();
                })
                .catch(error => {
                  this.alertError(error);
                });
            }
          });
        }
      });
    },
    downloadOffer(items) {
      Swal.fire({
        title: 'Preuzmi ponudu',
        html: `<div class="invoice-prompt">
                      <div>
                          <span>
                              Porez %
                          </span>
                          <input 
                              type="number" 
                              id="invoiceVat"
                              step="1"
                              min="1"
                              value="21">
                          </input>
                      </div>
                      <div>
                          <span>
                              Prikaži zbirno
                          </span>
                          <input 
                              type="checkbox"
                              id="invoiceShowTotal"
                              ></input>
                      </div>
                      </div>`,
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success',
        cancelButtonClass: 'md-button md-danger',
        confirmButtonText: 'Preuzmi!',
        cancelButtonText: 'Otkaži',
        buttonsStyling: false,
      }).then(data => {
        if (data.value) {
          const ids = items.map(el => el.id);
          const vat = document.getElementById('invoiceVat').value;
          const showTotal = document.getElementById('invoiceShowTotal').checked;
          api
            .post(services.offers.createOfferLog, {
              createInvoice: true,
              vat,
              ids,
              showTotal,
            })
            .then(({ id }) => api.get(services.offers.getOfferLogPdf, { id }))
            .then(pdfData => openPdfInNewTab(pdfData))
            .then(() => this.getOffersOrOfferGroups())
            .catch(error => {
              this.alertError(error);
            });
        }
      });
    },
    generateConfirmedOffers(items) {
      const ids = items.map(el => el.id);
      return Swal.fire({
        title: 'Generiši radne naloge?',
        text: `Da li ste sigurni da želite da generišete ${ids.length} ${cases(
          ids.length,
          'radni nalog',
          'radna naloga',
          'radnih naloga',
        )}?`,
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: 'Generiši!',
        cancelButtonText: 'Otkaži',
        buttonsStyling: false,
      }).then(({ value }) => {
        if (!value) return;

        api
          .post(services.offers.generateConfirmedOffers, { ids })
          .then(({ confirmedOfferIds }) => {
            const paramId = confirmedOfferIds.join('|');
            const route = this.$router.resolve({
              path: '/files',
              query: { filter: 'confirmed', paramId },
            });

            window.open(route.href, '_blank');
          })
          .then(() => {
            this.getOffersOrOfferGroups();
            this.$refs.table.removeChecked();
          })
          .catch(error => {
            this.alertError(error);
          });
      });
    },
    updateInvoiceCheck(checked) {
      const isInvoiced = file => {
        if (typeof file.invoiced === 'string') {
          return ['true', 'partial'].includes(file.invoiced);
        } else if (typeof file.invoiced === 'number') {
          return file.invoiced === 1;
        }
      };

      const clients = [];
      let invoiceCheck = true;
      let splitCheck = this.isFilterOn('confirmed');
      let someIsChecked = false;
      this.numOfChecked = 0;
      checked.forEach((el, index) => {
        const fileIndex = index;
        if (el) {
          someIsChecked = true;
          this.numOfChecked++;
          if (!clients.includes(this.modifiedFiles[fileIndex].clientName))
            clients.push(this.modifiedFiles[fileIndex].clientName);
          if (isInvoiced(this.modifiedFiles[fileIndex])) invoiceCheck = false;
          if (!this.highlightRows.includes(fileIndex)) {
            splitCheck = false;
          }
        }
      });
      this.canGetInvoice = clients.length === 1 && invoiceCheck;
      this.canGetOffer = clients.length === 1;
      this.canSplit = splitCheck && someIsChecked;
    },
    generateInvoice(items) {
      const ids = items.map(el => el.id);
      Swal.fire({
        title: 'Fakturiši?',
        html: `<div>
                  <span>
                      <i class="md-icon md-icon-font md-theme-default">
                        local_atm
                      </i>
                      ?
                  </span>
                  <input 
                      type="checkbox"
                      id="invoiceCash"
                      ></input>
              </div>`,
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success',
        cancelButtonClass: 'md-button md-danger',
        confirmButtonText: 'Fakturiši!',
        cancelButtonText: 'Otkaži',
        buttonsStyling: false,
      }).then(data => {
        if (data.value) {
          const invoiceCash = document.getElementById('invoiceCash').checked;
          api
            .post(services.offers.downloadInvoice, {
              createInvoice: true,
              ids,
              invoiceCash,
            })
            .then(() => {
              this.getOffersOrOfferGroups();
              this.canGetInvoice = false;
              this.$refs.table.removeChecked();
            })
            .catch(error => {
              this.alertError(error);
            });
        }
      });
    },
    linkGroup(items) {
      const ids = items
        .flatMap(item => String(item.id).split(','))
        .filter((value, index, array) => array.indexOf(value) === index);
      ids.sort((a, b) => parseInt(a) - parseInt(b));

      api
        .post(services.offers.linkOffers, {
          linkOffers: true,
          ids,
        })
        .then(() => {
          if (ids.length > 1) {
            this.selectedGroup = ids.join(',');
            this.$refs.table.lastIndex = this.selectedGroup;
          } else {
            this.selectedGroup = null;
            this.$refs.table.lastIndex = ids[0];
          }
          this.files = [];
          this.$refs.table.removeChecked();
          this.getOffersOrOfferGroups();
        })
        .catch(error => {
          this.alertError(error);
        });
    },
    splitGroup(items) {
      const ids = items.map(item => item.id);
      api
        .post(services.offers.splitOffers, {
          splitOffers: true,
          ids,
        })
        .then(() => {
          this.selectedGroup = null;
          this.files = [];
          this.$refs.table.removeChecked();
          this.getOffersOrOfferGroups();
        })
        .catch(error => {
          this.alertError(error);
        });
    },
  },
  mounted() {
    if (this.isFilterOn('confirmed'))
      document.title = 'Radni nalozi - WebToPrint';
    this.modifyParams();
    if (this.$route.query?.paramId) {
      this.params.id = this.$route.query.paramId;
      this.params.confirmed = ['1', '0'];
    }
    this.getOffersOrOfferGroups();
  },
  watch: {
    $route(to, from) {
      this.canGetInvoice = false;
      if (to.query?.filter !== from.query?.filter) {
        this.canGetOffer = false;
        this.files = [];
        this.$refs.table.currentSort = null;
        this.modifyParams();
        this.getOffersOrOfferGroups();
      }
      if (this.isFilterOn('confirmed'))
        document.title = 'Radni nalozi - WebToPrint';
    },
  },
};
</script>
